/* Marca PASCOM (Design System): logo oficial en negro sobre fondos claros, asset local versionado (nunca remoto). */
import logo1x from '/brand/logo-pascom-black.png?url';
import logo2x from '/brand/logo-pascom-black@2x.png?url';

export const SYSTEM_NAME = 'SGR — Sistema de Gestión de Rendiciones';

/** Logo PASCOM con proporción original (280×79). `height` en px; el ancho se deriva para no deformar la marca. */
export function BrandLogo({ height = 28, className, title = 'PASCOM' }: { height?: number; className?: string; title?: string }) {
  return <img src={logo1x} srcSet={`${logo1x} 1x, ${logo2x} 2x`} alt={title} height={height} width={Math.round(height * (280 / 79))} className={className} style={{ display: 'block', height, width: 'auto' }} decoding="async" />;
}

/** Bloque de marca: logo + identificación textual del sistema (el nombre funcional no se sustituye por el logo). */
export function BrandBlock({ logoHeight = 28, compact = false, align = 'start' }: { logoHeight?: number; compact?: boolean; align?: 'start' | 'center' }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: align === 'center' ? 'center' : 'flex-start', gap: 6 }}>
      <BrandLogo height={logoHeight} />
      <span style={{ fontSize: compact ? 11 : 'var(--fs-xs)', fontWeight: 600, letterSpacing: '.06em', color: 'var(--sgr-text-muted)', textTransform: compact ? 'uppercase' : 'none', textAlign: align }}>{compact ? 'SGR' : SYSTEM_NAME}</span>
    </div>
  );
}
